import { render, staticRenderFns } from "./AddressEditModal.vue?vue&type=template&id=6b98564e&"
import script from "./AddressEditModal.vue?vue&type=script&lang=js&"
export * from "./AddressEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports